module.exports = __webpack_public_path__ + "img/bg_tecnico.1bb5b556.jpg";